export default __webpack_public_path__ + "static/media/closePopup.48af1c5d.svg";